import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import LimitOrder from './LimitOrder';
import OrderBookRow from './OrderBookRow';
import MarketOrders from './MarketOrders';
import * as firebase from 'firebase';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';

const quips = [
  "G7 Nations Announce Mandatory Corporate Carbon Offset Requirements by 2030...",
  "Amazon Rainforest Enters International Carbon Custodianship Program...",
  "China Expands National Emissions Trading Scheme to Cement and Petrochemicals...",
  "SEC Finalizes Rule Requiring Carbon Credit Disclosures in ESG-Linked Securities...",
  "BlackRock Launches $10 Billion Fund Focused on Carbon Removal Projects...",
  "UN Suspends 200+ Carbon Offset Projects Citing Verification Failures...",
]
// const quips = ["Calling in favors...", "I hear the pound just went down against the dollar...","Trade tariffs or summat...", "Betting against USD...", "On the phone with the SEC..."]
  // Agricola:    (Lucas likes cows)
  //"I'll trade you a cow for 2 gold...", "Well, I'll trade you 2 cows for 4 sheep...", "I mean, we all know cows are the best resource; they're worth more than either farmland squares or pastures ...", "Well then I'll trade you 4 sheep for the 2 US dollars instead...",
  // Monty Python:
  /* "Lol heres some more text...", "Paying for the Spanish Inquisition...", "Come back here and fight like a Man! ...",  "I'll bite your legs off! ...",  "WE are the knights who say \"Ni\" ! ...",*/
  // The inimitible "All Star", by Smash Mouth:
   //"SomeBODY once told me the WORLD was gonna roll me ...", "Well, the years start coming and they don't stop coming, something something to the rules, and I hit the ground RUNnin ...", "Didn't make sense not to live for fun ...", "Your brain gets smart but your head gets duuuumb ...",  "So much to DO, so much to SEE, so what's WRONG with taaaaking the BACK streets? ...",  "You never shine if you don't glow ...", "Hey now, you're an All Star ...",  "Get the GAME on, GO... PLAYYY ...", /*I'm missing some lyrics here; fill em in if you remember 'em / take the time to (TODO) Google 'em*/ "And ALLLLlll that glitters is goooold ...", "Only shooting staaars, break the mooowuOLD ..."];    
  // these quips used to say  "Misplaced your cash...", and "embezzling funds" before Bruce wanted it out for being too unprofessional.  In fairness, I agree. If a prof sees "Embezzling Funds" in the software they paid for, it's a little sketch.  We can debate it at the next meeting.  -Nathan Bendich, August 14, 2022,
let firstCenter = false;
/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class OrderbookContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            // midPoints: [],
            paused: false,
            LastPrice: '-',
            priceTimes: 0,
            focused: false,
            auctionStrike: 20.00,
            auctionOnly: true,
            inAuction: false,
            quip: quips[Math.floor(Math.random() * quips.length)],
            userSums: {"Bid":{},"Ask":{}},
            orderBookSums: {"Bid":{},"Ask":{}}
        };

        this.userValues = {};
        this.orderBookValues = {};
        this.strikes=[];

        this.vwapRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC");

        this.vwapRef.once('value', snap => {
          console.log("VWAP",snap.val());
          if (snap.val()) {
              this.setState({
                  LastPrice: ((parseFloat(snap.val().CurrentAssetPrice) + 25) / 100).toFixed(2),
                  priceTimes: 1
              });
          } else {
              this.setState({
                  LastPrice: '20.00'
              });
          }
          console.log(this.state.LastPrice);
        });

    }

    //sets quip state to display quips on a timer
    getQuip() {
        //console.log("OrderbookContainer getQuip");
        this.setState({
            quip: quips[Math.floor(Math.random() * quips.length)]
        })
    }

    auctionOnlyClick() {
      this.setState({
        auctionOnly: !this.state.auctionOnly
      });
    }

    updateAuctionStrike(){
      let bids = this.state.orderBookSums.Bid;
      let asks = this.state.orderBookSums.Ask;
      let strikes = Object.keys(bids);
      let matches = [];
      strikes.map(strike=>{
        if (asks.hasOwnProperty(strike)){
          if (asks[strike] > 0 && bids[strike] > 0){
            matches.push([strike, Math.min(asks[strike], bids[strike])]);
          }
        }
      });
      if (matches.length === 0){
        this.setState({auctionStrike: "-"});
        return;
      }
      let maxStrikes = [];
      let maxVal = 0;
      let diffSpread = 10000000;
      matches.map(pair=>{
        let val = pair[1];
        if (val > maxVal){
          maxVal = val;
          maxStrikes = [pair[0]];
          diffSpread = Math.abs(bids[pair[0]] - asks[pair[0]]);
        } else if (val == maxVal){
          var tempDiff = Math.abs(bids[pair[0]] - asks[pair[0]]);
          if (diffSpread > tempDiff){
            maxStrikes = [pair[0]];
            diffSpread = tempDiff;
          } else if (diffSpread == tempDiff){
            maxStrikes.push(pair[0]);
          }
        }
      });
      if (maxStrikes.length == 1){
        this.setState({auctionStrike: maxStrikes[0]});
        return;
      }

      maxStrikes.sort();
      let winner = maxStrikes[Math.floor(maxStrikes.length/2)];
      this.setState({auctionStrike: winner});
      return;
    }

    setAuctionRowValue(dataObj){
      var that = this;
      let calculateSums = function(obObj, orderType){
        var strikes = [...new Set([...Object.keys(obObj) ,...that.strikes])];
        strikes.sort(); //low to high
        var response = {};
        if (orderType == "Bid"){
          strikes.reverse();
        }
        var prev = 0;
        strikes.forEach(strike=>{
          if (obObj.hasOwnProperty(strike)){
            response[strike] = prev + parseInt(obObj[strike][orderType] || 0);
            prev = response[strike];
          } else {
            response[strike] = prev;
          }
        });
        return response;
      }

      if (dataObj.hasOwnProperty("shortcut")){
        let orderBookSums = Object.assign({}, this.state.orderBookSums);
        orderBookSums["Bid"] = calculateSums(this.orderBookValues, "Bid");
        orderBookSums["Ask"] = calculateSums(this.orderBookValues, "Ask");
        console.log(   "\n\n====="  ) ;
        console.log(   "JSON.stringify(orderBookSums['Ask'])"  ) ;
        console.log(   JSON.stringify(orderBookSums["Ask"])  ) ;
        console.log(   "\n\n====="  ) ;
        this.setState({orderBookSums});
        this.updateAuctionStrike();
        return;
      }

      if (dataObj.hasOwnProperty("shortcutuser")){
        let userSums = Object.assign({}, this.state.userSums);
        userSums["Bid"] = calculateSums(this.userValues, "Bid");
        userSums["Ask"] = calculateSums(this.userValues, "Ask");
        this.setState({userSums});
        return;
      }

      let strike = dataObj.strike;
      let isUser = dataObj.isUser;
      let newValue = dataObj.newValue;
      let orderType = dataObj.orderType; //Ask or Bid

      let updateOrSet = function(theObj, orderType, strike, newValue){
        if (!theObj.hasOwnProperty(strike)){
          theObj[strike] = {"Bid": 0, "Ask": 0};
        }
        theObj[strike][orderType] = newValue;
      }


      if (isUser){
        updateOrSet(this.userValues, orderType, strike, newValue);
        if (dataObj.hasOwnProperty("delay")){
          return;
        }
        let userSums = Object.assign({}, this.state.userSums);
        userSums[orderType] = calculateSums(this.userValues, orderType);
        this.setState({userSums});
      } else {
        updateOrSet(this.orderBookValues, orderType, strike, newValue);
        if (dataObj.hasOwnProperty("delay")){
          return;
        }
        let orderBookSums = Object.assign({}, this.state.orderBookSums);
        orderBookSums[orderType] = calculateSums(this.orderBookValues, orderType);
        //update auctionStrike
        this.setState({orderBookSums});
        this.updateAuctionStrike();
      }
    }

    shouldComponentUpdate(){
      if (this.canRender){
        this.canRender = false;
        return true;
      }
      return false;
    }

    componentDidMount() {
        //console.log("OrderbookContainer componentDidMount");
        this.aggobRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("AggOB");
        this.middlePointRef = this.props.db.child("Sessions").child(this.props.sessionid).child("ImportantData").child("SessionData");
        this.pausedRef = this.props.db.child("Sessions").child(this.props.sessionid).child('StartSim').child('running');
        this.valRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Assets").child("INTC").child("orderbook");
        this.auctionRef = this.props.db.child("Sessions").child(this.props.sessionid).child("inAuction");
        //declares quip automation timer
        this.quipsTimer = setInterval(this.getQuip.bind(this), 5000);
        this.canRender = true;
        this.renderLoop = setInterval(()=>{ this.canRender = true; }, 1000);

        let strike, bid, ask;

        //this listener deals with determining if the sim is paused
        this.pausedRef.on('value', snap => {
            let rawData = snap.val();
            if (rawData) {
                this.setState({
                    paused: false
                });
            } else {
                this.setState({
                    paused: true
                });
            }
        });

        this.auctionRef.on('value', snap => {
          let inAuction = !!snap.val();
          this.setState({inAuction: inAuction});
          if (inAuction){
            this.setAuctionRowValue({"shortcutuser":true});
            this.setAuctionRowValue({"shortcut":true});
          }
        });

        //this listener deals with checking the middle bid
        //and ask points
        // this.middlePointRef.on('value', snap => {
        //   let rawData = snap.val();
        //   if (!!rawData) {
        //     var midPoints = [];
        //     //let midPoints = [];
        //     //console.log(rawData);
        //     midAsk = rawData.ask;
        //     midBid = rawData.bid;
        //     midPoints.push({
        //       midAsk: midAsk,
        //       midBid: midBid
        //     });
        //     //console.log(midAsk,midBid);
        //     this.setState({
        //       midPoints: midPoints
        //     });
        //   }
        // })

        //this listener deals with getting current strikes, bid,
        //and ask. Also deals with setting ready state
        this.aggobRef.on('value', snap => {
            let rawData2 = snap.val();
            if (rawData2) {
                //console.log(rawData);
                rawData2 = Object.assign({"1800": {"Bid":0,"Ask":0}, "2200": {"Bid":0,"Ask":0}}, rawData2)
                var range = Object.keys(rawData2).map(y=>parseInt(y));
                range = range.filter(val=>{return val == parseInt(val)});
                var min = Math.min.apply(null, range)
                var max = Math.max.apply(null, range)
                var masterObj={}
                console.log(((max-min)/5) + 1, max, min);
                Array(((max-min)/5) + 1).fill().map((_,i)=> min + i*5).map(akey=>{if (!!akey){ masterObj[akey] = {Strike: akey.toString(), Bid: 0, Ask: 0} } })
                var rawData = Object.assign(masterObj, rawData2);

                var tempStrikes = [];
                var ords = [];
                for (var key in rawData) {
                    if (!(parseInt(key) > 0)){
                      continue;
                    }
                    //rawStrike = key;
                    strike = (key / 100).toFixed(2);
                    if (!(parseInt(strike) > 0)){
                      continue;
                    }//NaN fighting
                    tempStrikes.push(strike);
                    bid = rawData[key].Bid;
                    if (bid === undefined) {
                        bid = 0;
                    }
                    ask = rawData[key].Ask;
                    if (ask === undefined) {
                        ask = 0;
                    }
                    if (bid === 0) {
                        bid = "";
                    }
                    if (ask === 0) {
                        ask = "";
                    }
                    ords.push({
                        "Strike": strike,
                        "Bid": bid,
                        "Ask": ask
                    });
                    /*    let strike = dataObj.strike;
                          let isUser = dataObj.isUser;
                          let newValue = dataObj.newValue;
                          let orderType = dataObj.orderType;*/
                    this.setAuctionRowValue({strike: strike, isUser: false, newValue: bid, orderType: "Bid", delay: true});
                    this.setAuctionRowValue({strike: strike, isUser: false, newValue: ask, orderType: "Ask", delay: true});
                }
                this.strikes = tempStrikes;
                this.setState({
                    orders: ords.reverse(),
                    ready: true
                });
                this.setAuctionRowValue({shortcut: true});
                this.props.onReady();
            } else {
                //var ords = [];
                this.setState({
                    orders: ords,
                    ready: false
                });
            }
        })
    }

    componentWillUnmount() {
        //console.log("OrderbookContainer componentWillUnmount");
        clearInterval(this.quipsTimer);
        this.aggobRef.off();
        this.middlePointRef.off();
        this.pausedRef.off();
        this.auctionRef.off();
    }

    wasScrolled(){
      this.setState({focused: true});
    }

    centerit() {
      let obs = this.state.orderBookSums;
      let bid = 0;
      let ask = 10000;
      Object.keys(obs.Bid).map(strk=>{
        if (obs.Bid[strk] > 0){
          if (parseFloat(strk) > bid){
            bid = parseFloat(strk);
          }
        }
      });
      Object.keys(obs.Ask).map(strk=>{
        if (obs.Ask[strk] > 0){
          if (parseFloat(strk) < ask){
            ask = parseFloat(strk);
          }
        }
      });
      let bidid = (bid*100).toFixed(0);
      let askid = (ask*100).toFixed(0);
      let almost = Math.floor((parseInt(bidid)+parseInt(askid)-60)/2)
      almost += 5 - (almost % 5);
      let minid = almost.toFixed(0);
      let maxid = (almost+60).toFixed(0);
      //min, bid, ask, min+60 find min where bid - min == min+60-ask
      try{
        document.getElementById(minid).scrollIntoView();
        document.getElementById(maxid).scrollIntoView();
        document.querySelector(".header").scrollIntoView();
        firstCenter = true;
      } catch(err){
        console.log(err);
      }
//      alert(`Bid: ${bidid} Ask: ${askid}`);
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
        if (!firstCenter){
          this.centerit();
        }
        return (
            <div className="orderBookContainerStyle">
                <div className="auctionHeader">
                  {this.state.inAuction &&
                    <h3>Call Auction is LIVE</h3>
                  }
                  <div className={`${(!this.state.inAuction ? 'hidden' : '')} auctionOnlyInput`}>
                    <label for="isAuctionOnly">New Orders <span>{this.state.auctionOnly ? "ARE" : "NOT"}</span> Auction-Only </label>
                  </div>
                </div>
                {!this.state.inAuction &&
                  <MarketOrders
                    institution={this.props.institution}
                    paused={this.state.paused}
                    uid={this.props.uid}
                    db={this.props.db}
                    sessionid={this.props.sessionid}
                    centerme={this.centerit.bind(this)}
                  />
                }
                <table className='orderBookTableStyle'>
                    <thead className='orderBookHeader'>
                    <tr className='orderBookHead'>
                        <th  style={{width: "12rem"}} >Limit Bid</th>
                        <th className=''>Bids</th>
                        <th className=''>Price</th>
                        <th className=''>Asks</th>
                        <th className="" style={{width: "12rem"}} >Limit Ask</th>
                    </tr>
                    </thead>
                    <tbody className='orderBookTableBody'>
                    {this.state.ready
                        ?
                        this.state.orders.map(function (ord, index) {
                            return (
                                <OrderBookRow
                                    institution={this.props.institution}
                                    paused={this.state.paused}
                                    key={`${JSON.stringify(ord.Strike)}:${index}`}
                                    uid={this.props.uid}
                                    db={this.props.db}
                                    sessionid={this.props.sessionid}
                                    Bid={((this.state.inAuction) ? ( (this.state.orderBookSums.Bid.hasOwnProperty(ord.Strike)) ? this.state.orderBookSums.Bid[ord.Strike] : "") : ord.Bid)}
                                    Strike={ord.Strike}
                                    highlight={this.state.auctionStrike == ord.Strike && this.state.inAuction}
                                    StartCenter={!this.state.focused && this.state.LastPrice == ord.Strike}
                                    WasScrolled={this.wasScrolled.bind(this)}
                                    Ask={((this.state.inAuction) ? ( (this.state.orderBookSums.Ask.hasOwnProperty(ord.Strike)) ? this.state.orderBookSums.Ask[ord.Strike] : "") : ord.Ask)}
                                    inAuction = {this.state.inAuction}
                                    reportChange = {this.setAuctionRowValue.bind(this)}
                                    auctionUserBid = {((this.state.inAuction) ? ( (this.state.userSums.Bid.hasOwnProperty(ord.Strike)) ? this.state.userSums.Bid[ord.Strike] : "") : "")}
                                    auctionUserAsk = {((this.state.inAuction) ? ( (this.state.userSums.Ask.hasOwnProperty(ord.Strike)) ? this.state.userSums.Ask[ord.Strike] : "") : "")}
                                    isAuctionOnly={this.state.inAuction && this.state.auctionOnly} /* When auction ON then use user preference (defaulting to true) else use FALSE */
                                    />
                            );
                        }.bind(this))

                        :
                        <tr>
                            <div>
                                {this.state.quip}
                            </div>
                        </tr>
                    }
                    </tbody>
                </table>
            </div>
        );
    }
}

OrderbookContainer.propTypes = {
    sessionid: PropTypes.string,
    uid: PropTypes.string
};

export default OrderbookContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/OrderbookContainer.js